module.exports = __webpack_public_path__ + "assets/img/2026-meeting-reconvented-after.7e768c05.webp";